<template>
    <div class="proveedores">
        <h2 class="subheading grey--text">{{$t('proveedores')}}</h2>
        <v-container class="my-5">
            <!--     Dialog Mostrar Erorores del Celular     -->
            <v-dialog v-model="dialog_cellphone" persistent max-width="290">
                <v-card>
                    <v-card-title class="headline">{{$t('aviso')}}</v-card-title>
                    <v-card-text>{{$t('cellphone_wrong')}}</v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" flat @click="dialog_cellphone = false, dialog_supplier = true">{{$t('aceptar')}}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <!--Dialog Upgrade User to Supplier-->
            <v-dialog
                    v-model="dialog_move_up"
                    max-width="450"
            >
                <v-form @submit.prevent="upgradeUserToSupplier()">
                    <v-card class="elevation-5">
                        <v-toolbar dark color="primary">
                            <v-toolbar-title>
                                {{$t('move_up_supplier')}}
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn
                                    class="align-self-end"
                                    color="red"
                                    icon
                                    @click="dialog_move_up = false">
                                <v-icon>close</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-card-text>
                            <v-layout row wrap>
                                <v-autocomplete
                                        v-model="email2"
                                        :items="items"
                                        prepend-icon="email"
                                        :loading="isLoading"
                                        :search-input.sync="search2"
                                        :item-text="fullNamePlusCellphone"
                                        item-value="id"
                                        :placeholder="$t('placeholder_invitados2')"
                                        :label="$t('usuarios')"
                                        :error-messages="errores.idUsuario"
                                        :no-data-text="$t('no_resultados')"
                                        clearable
                                >
                                    <template v-slot:selection="data">
                                        <v-chip
                                                :selected="data.selected"
                                                class="chip--select-multi"
                                        >
                                          <v-avatar>
                                            <img :src="data.item.avatar">
                                          </v-avatar>
                                          {{data.item.first_name}} {{data.item.last_name}}
                                        </v-chip>
                                    </template>
                                    <template v-slot:item="data">
                                      <v-list-tile-avatar>
                                        <img :src="data.item.avatar">
                                      </v-list-tile-avatar>
                                      {{data.item.first_name}} {{data.item.last_name}}
                                    </template>
                                </v-autocomplete>
                            </v-layout>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn
                                    color="primary"
                                    @click="dialog_move_up = false"
                            >
                                {{$t('cerrar')}}
                            </v-btn>
                            <v-spacer/>
                            <v-btn
                                    color="primary"
                                    type="submit"
                                    :loading="loading"
                            >
                                {{$t('modificar')}}
                                <v-icon dark right>arrow_upward</v-icon>
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-dialog>
            <!--     Dialog Formulario Alta Proveedor      -->
            <v-layout align-center justify-center fill-height>
            <v-dialog v-model="dialog_supplier" persistent max-width="400">
                <template v-slot:activator="{ on }">
                    <v-btn
                            color="primary"
                            dark
                            v-on="on"
                            @click="dialog_supplier = true, cleanFieldsSupplier()"> + {{$t('Anadirproveedor')}}
                    </v-btn>
                    <v-btn
                            v-show="getProfile.roll === 5 || getProfile.roll === 1"
                            arrow_upward
                            color="primary"
                            @click="errores = [], entries = [], dialog_move_up = true"
                    >
                        <v-icon dark left>swap_horiz</v-icon>
                        {{$t('cambiar_permisos')}}
                    </v-btn>
                </template>
                <v-form @submit.prevent="send_supplier_data()">
                    <v-card class="elevation-5">
                        <v-toolbar dark color="primary">
                            <v-toolbar-title>
                                {{$t('data_company')}}
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn
                                    class="align-self-end"
                                    color="red"
                                    icon
                                    @click="dialog_supplier = false">
                                <v-icon>close</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-card-text>
                            <v-layout row wrap>
                                <v-flex>
                                    <v-text-field
                                            autofocus
                                            box
                                            class="pt-2 pb-2 pl-2 pr-2"
                                            v-model="supplier_first_name"
                                            prepend-inner-icon="person"
                                            name="supplier_first_name"
                                            :label="$t('Nombre')"
                                            :error-messages="errors_supplier.first_name"
                                    >
                                    </v-text-field>
                                    <v-text-field
                                            box
                                            class="pt-2 pb-2 pl-2 pr-2"
                                            v-model="supplier_last_name"
                                            prepend-inner-icon="person_outline"
                                            name="supplier_last_name"
                                            :label="$t('Apellido')"
                                            :error-messages="errors_supplier.last_name"
                                    >
                                    </v-text-field>
                                    <vue-phone-number-input
                                            default-country-code="MX"
                                            color="#D32F2F"
                                            valid-color="#2196F3"
                                            @update="onChange"
                                            v-model="supplier_cellphone"
                                            :translations="custom_cell_phone"
                                            :error-messages="errors_supplier.celular"
                                    >
                                    </vue-phone-number-input>
                                    <v-alert
                                            :value="errors_supplier.celular"
                                            type="error"
                                            transition="scale-transition"
                                    >
                                        {{errors_supplier.celular}}
                                    </v-alert>
                                    <v-text-field
                                            box
                                            class="pt-2 pb-2 pl-2 pr-2"
                                            v-model="supplier_email"
                                            prepend-inner-icon="email"
                                            name="supplier_email"
                                            label="E-Mail"
                                            :error-messages="errors_supplier.email"
                                    >
                                    </v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer/>
                            <v-btn
                                    color="primary"
                                    type="submit"
                                    :loading="loading"
                            >
                                {{$t('enviar')}}
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-dialog>
            </v-layout>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-layout class="my-4" align-center justify-center fill-height>
                <v-flex >
                    <v-card-title>
                        {{$t('proveedores')}}
                        <v-spacer></v-spacer>
                        <v-text-field
                                v-model="search"
                                append-icon="search"
                                :label="$t('Buscar')"
                                single-line
                                hide-details
                        ></v-text-field>
                    </v-card-title>
                    <v-data-table
                            :headers="headers"
                            :loading="loading_data_empresas"
                            :items="empresas"
                            :search="search"
                            class="elevation-1"
                            :rows-per-page-text="$t('filas_por_pagina')"
                            :no-data-text="$t('no_registros_proveedores')"
                            :rows-per-page-items="[
                            {text: '5', value: 5},
                            {text: '10', value: 10},
                            {text: '25', value: 25},
                            {text: this.$t('todos'),
                            value: -1}]"
                    >
                        <template v-slot:items="props">
                            <!--<td class="justify-center layout px-0">-->
                                <!--<v-icon-->
                                        <!--small-->
                                        <!--class="mr-2"-->
                                        <!--@click="fill_fields(props.item), update = true, dialog = true, id_update = props.item.id"-->
                                <!--&gt;-->
                                    <!--edit-->
                                <!--</v-icon>-->
                            <!--</td>-->
                            <td>{{ props.item.companyProvider.name }}</td>
                            <td>{{ props.item.companyProvider.address }}</td>
                            <td>{{ props.item.companyProvider.telephone }}</td>
                            <td>{{ props.item.companyProvider.email }}</td>
                            <td>
                                <v-img
                                    :src="props.item.companyProvider.logo">
                                </v-img>
                            </td>
                            <!--<td>{{ props.item.companyProvider.logo }}</td>-->
                            <td>{{ props.item.companyProvider.web_page }}</td>
                            <td>{{ props.item.companyProvider.scian }}</td>
                            <td>{{ props.item.companyProvider.classification }}</td>
                            <!--<td>{{ props.item.companyProvider.latitude }}</td>-->
                            <!--<td>{{ props.item.companyProvider.longitude }}</td>-->
                            <!--<td>{{ props.item.companyProvider.url_map }}</td>-->
                            <!--<td>{{ props.item.companyProvider.validity }}</td>-->
                            <!--<td>{{ props.item.companyProvider.id_parque }}</td>-->
                        </template>
                        <template v-slot:no-results>
                            <v-alert :value="true" color="error" icon="warning">
                                {{$t('ningun_resultado_1')}} "{{ search }}" {{$t('ningun_resultado_2')}}
                            </v-alert>
                        </template>
                        <template v-slot:pageText="props">
                            {{props.rowsPerPage}}
                            {{$t('proveedores')}} {{ props.pageStart }} - {{ props.pageStop }} {{$t('prep_de')}} {{ props.itemsLength }}
                        </template>
                    </v-data-table>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
    import '@/plugins/axios'
    import store from '@/store'
    import Vue from 'vue'
    import VeeValidate from 'vee-validate'
    import VuePhoneNumberInput from 'vue-phone-number-input'
    import 'vue-phone-number-input/dist/vue-phone-number-input.css'

    Vue.use(VeeValidate)
    Vue.component('vue-phone-number-input', VuePhoneNumberInput)
    import { mapState, mapGetters} from 'vuex'

    export default {
        name: "proveedores",
        data: () => ({
            alerta: false,
            calendario: false,
            parques: [],
            administradores: [],
            empresas: [],
            dialog: false,
            update:false,
            id_update: 0,
            name: '',
            address: '',
            telephone:'',
            email: '',
            logo: '',
            web_page: '',
            scian: '',
            classification: '',
            latitude: '',
            longitude: '',
            url_map: '',
            validity: '',
            id_parque: '',
            errores: [],
            search: '',
            headers: [],
            loading_data_empresas: false,
            loading: false,
            logo_imageUrl: '',
            logo_imageName: '',
            logo_imageFile: '',
            dialog_supplier: false,
            errors_supplier: [],
            supplier_first_name: '',
            supplier_last_name: '',
            supplier_email: '',
            supplier_cellphone: '',
            custom_cell_phone: { },
            band_cellphone: false,
            cellphone_plus_country_code: '',
            dialog_cellphone: false,
            // Variables Upgrade User to Supplier
            dialog_move_up: false,
            email2: null,
            search2: null,
            entries: [],
            isLoading: false
        }),
        beforeUpdate(){
            this.custom_cell_phone ={
                "countrySelectorLabel": this.$t('codigo_pais'),
                "phoneNumberLabel": this.$t('celular'),
                "example": this.$t('ejemplo')
            },
            this.headers = [
                // {
                //     text: this.$t('modificar'),
                //     align: 'left',
                //     sortable: false,
                //     value: 'update'
                // },
                {
                    text: this.$t('nombre'),
                    align: 'left',
                    sortable: true,
                    value: 'companyProvider.name'
                },
                {
                    text: this.$t('direccion'),
                    align: 'left',
                    sortable: true,
                    value: 'companyProvider.address'
                },
                {
                    text: this.$t('telefono'),
                    align: 'left',
                    sortable: true,
                    value: 'companyProvider.telephone'
                },
                {
                    text: 'E-Mail',
                    align: 'left',
                    sortable: true,
                    value: 'companyProvider.email'
                },
                {
                    text: this.$t('logotipo'),
                    align: 'center',
                    sortable: false,
                    value: 'companyProvider.logo'
                },
                {
                    text: this.$t('pagina_web'),
                    align: 'left',
                    sortable: true,
                    value: 'companyProvider.web_page'
                },
                {
                    text: 'SCIAN',
                    align: 'left',
                    sortable: true,
                    value: 'companyProvider.scian'
                },
                {
                    text: this.$t('clasificacion'),
                    align: 'left',
                    sortable: true,
                    value: 'companyProvider.classification'
                },
                // {
                //     text: this.$t('latitud'),
                //     align: 'left',
                //     sortable: true,
                //     value: 'latitude'
                // },
                // {
                //     text: this.$t('longitud'),
                //     align: 'left',
                //     sortable: true,
                //     value: 'longitude'
                // },
                // {
                //     text: this.$t('url_mapa'),
                //     align: 'left',
                //     sortable: true,
                //     value: 'url_map'
                // },
                // {
                //     text: this.$t('vigencia'),
                //     align: 'left',
                //     sortable: true,
                //     value: 'validity'
                // },
                // {
                //     text: 'ID_Parque',
                //     align: 'left',
                //     sortable: true,
                //     value: 'id_parque'
                // }
            ]
        },
        created: function () {
            this.get_empresas()
        },
        watch: {
            isUpdating (val) {
                if (val) {
                    setTimeout(() => (this.isUpdating = false), 3000)
                }
            },
            search2 (val) {
                // Items have already been loaded
                //if (this.items.length > 0) return

                // Items have already been requested
                //if (this.isLoading) return
              if (val !== undefined && val !== null) {
                if (val.length > 2){

                  this.isLoading = true

                  // Lazily load input items
                  const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/simpleUser/filter?search=' + val,
                    headers: {
                      'Content-Type': 'application/json',
                      'authorization': 'Token ' + store.getters.getToken
                    }
                  };
                  axios(config)
                    .then(response => {
                      console.log(response.data)
                      if(this.entries.length > 0){
                        for(var i =0 ; i < response.data.length; i++){
                          this.entries.push(response.data[i])
                        }
                      }
                      else
                        this.entries = response.data
                    })
                    .catch(error => {
                      console.log(error)
                    })
                    .finally(() => (this.isLoading = false))
                }
              }
            }
        },
        computed: {
            ...mapState(['language']),
            ...mapGetters(['getProfile']),
            fields () {
                if (!this.email2) return []

                return Object.keys(this.email2).map(key => {
                    return {
                        key,
                        value: this.email2[key] || 'n/a'
                    }
                })
            },
            items () {
                return this.entries.map(entry => {
                    const email = entry.email.length > this.descriptionLimit
                        ? entry.email.slice(0, this.descriptionLimit) + '...'
                        : entry.email

                    return Object.assign({}, entry, { email })
                })
            }
        },
        methods: {
            get_parques(){
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/parques/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        this.parques = response.data
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            get_empresas: function(){
                this.loading_data_empresas = true
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/getProvidersByAdmin',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        this.empresas = response.data
                        this.loading_data_empresas = false
                    })
                    .catch(error => {
                        this.loading_data_empresas = false
                        console.log(error)
                    })
            },
            alta_empresa: function () {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        if (this.id_parque == null)
                            this.id_parque = ''
                        var bodyFormData = new FormData()

                        bodyFormData.set('name', this.name)
                        bodyFormData.set('address', this.address)
                        bodyFormData.set('telephone', this.telephone)
                        bodyFormData.set('email', this.email.toLowerCase())
                        bodyFormData.append('logo', this.logo_imageFile)
                        bodyFormData.set('web_page', this.web_page)
                        bodyFormData.set('scian', this.scian)
                        bodyFormData.set('classification', this.classification)
                        bodyFormData.set('latitude', this.latitude)
                        bodyFormData.set('longitude', this.longitude)
                        bodyFormData.set('url_map', this.url_map)
                        bodyFormData.set('validity', this.validity)
                        bodyFormData.set('id_parque', this.id_parque)
                        const config = {
                            method: 'post',
                            url: 'https://empresa-service.intrare.app/empresas/',
                            headers: {
                                'Content-Type': 'multipart/form-data',
                                'Accept-Language': this.language ,
                                'authorization': 'Token ' + store.getters.getToken
                            },
                            data: bodyFormData
                        };
                        axios(config)
                            .then(ok => {
                                this.$store.commit('snackbar_activate_true')
                                this.$store.commit('snackbar_change_message', this.$t('mensaje_empresa_alta'))
                                this.dialog = false
                                this.get_empresas()
                                setTimeout(this.clear, 3000);
                            })
                            .catch(error => {
                                if(error.response.status == 400
                                    && typeof error.response.data == "object"
                                    && error.response.data)
                                    this.errores = error.response.data
                            })
                    }
                }).catch((e) => {
                    console.log(e);// Failed
                });

            },
            update_empresa(id){
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        if (this.id_parque == null)
                            this.id_parque = ''
                        var bodyFormData = new FormData()

                        bodyFormData.set('name', this.name)
                        bodyFormData.set('address', this.address)
                        bodyFormData.set('telephone', this.telephone)
                        bodyFormData.set('email', this.email.toLowerCase())
                        bodyFormData.append('logo', this.logo_imageFile)
                        bodyFormData.set('web_page', this.web_page)
                        bodyFormData.set('scian', this.scian)
                        bodyFormData.set('classification', this.classification)
                        bodyFormData.set('latitude', this.latitude)
                        bodyFormData.set('longitude', this.longitude)
                        bodyFormData.set('url_map', this.url_map)
                        bodyFormData.set('validity', this.validity)
                        bodyFormData.set('id_parque', this.id_parque)
                        const config = {
                            method: 'put',
                            url: 'https://empresa-service.intrare.app/empresas/'+ id +'/update/',
                            headers: {
                                'Content-Type': 'multipart/form-data',
                                'Accept-Language': this.language ,
                                'authorization': 'Token ' + store.getters.getToken
                            },
                            data: bodyFormData
                        };
                        axios(config)
                            .then(ok => {
                                console.log(this.id_parque)
                                this.get_empresas()
                                this.$store.commit('snackbar_activate_true')
                                this.$store.commit('snackbar_change_message', this.$t('mensaje_empresa_modificado'))
                                this.dialog = false
                                setTimeout(this.clear, 3000);
                            })
                            .catch(error => {
                                if(error.response.status == 400
                                    && typeof error.response.data == "object"
                                    && error.response.data)
                                    this.errores = error.response.data
                            })
                    }
                }).catch((e) => {
                    console.log(e);// Failed
                });
            },
            clear: function () {
                this.alerta = false
                this.errors_supplier = []
                this.$validator.reset()
                this.$store.commit('snackbar_activate_false')
            },
            fill_fields(item){
                this.name = item.name
                this.address = item.address
                this.telephone = item.telephone
                this.email = item.email
                this.logo = item.logo
                this.logo_imageUrl = item.logo
                this.web_page = item.web_page
                this.scian = item.scian
                this.classification = item.classification
                this.latitude = item.latitude
                this.longitude = item.longitude
                this.url_map = item.url_map
                this.validity = item.validity
                this.id_parque = item.id_parque
            },
            customFilter (item, queryText) {
                const textOne = item.nombre.toLowerCase()
                const searchText = queryText.toLowerCase()
                return textOne.indexOf(searchText) > -1
            },
            clean_fields(){
                this.name = ""
                this.address = ""
                this.telephone = ""
                this.email = ""
                this.logo = ""
                this.web_page = ""
                this.scian = ""
                this.classification = ""
                this.latitude = ""
                this.longitude = ""
                this.url_map = ""
                this.validity = ""
                this.id_parque = ""
                this.logo_imageUrl = ''
                this.logo_imageName = '',
                this.logo_imageFile = ''
            },
            cleanFieldsSupplier(){
                this.supplier_first_name = ''
                this.supplier_last_name = ''
                this.supplier_cellphone = ''
                this.cellphone_plus_country_code = ''
                this.band_cellphone = false
                this.supplier_email = ''
                this.errors_supplier = []
            },
            send_supplier_data(){
                if (this.band_cellphone === true)
                {
                    this.loading = true
                    this.$validator.validateAll().then((result) => {
                        if (result) {
                            this.errors_supplier = []
                            const config = {
                                method: 'post',
                                url: 'https://empresa-service.intrare.app/createProvider/',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Accept-Language': this.language ,
                                    'authorization': 'Token ' + store.getters.getToken
                                },
                                data: {
                                    first_name: this.supplier_first_name,
                                    last_name: this.supplier_last_name,
                                    email: this.supplier_email,
                                    celular: this.cellphone_plus_country_code
                                }
                            };
                            axios(config)
                                .then(ok => {
                                    this.$store.commit('snackbar_activate_true')
                                    this.$store.commit('snackbar_change_message', this.$t('enviar_reg_admin_proveedor'))
                                    this.dialog_supplier = false
                                    setTimeout(this.clear, 3000)
                                    this.loading = false
                                })
                                .catch(error => {
                                    if(error.response.status == 400
                                        && typeof error.response.data == "object"
                                        && error.response.data) {
                                        this.errors_supplier = error.response.data
                                        if (this.errors_supplier.celular) {
                                            this.errors_supplier.celular = "Ya existe un usuario registrado con este Celular."
                                        }
                                    }
                                    this.loading = false
                                })
                        }
                    }).catch((e) => {
                        console.log(e)// Failed
                    })
                } else {
                    this.dialog_cellphone = true
                    this.dialog_supplier = false
                }
            },
            get_current_date: function (){
                var today = new Date();
                var dd = today.getDate();
                var mm = today.getMonth()+1;
                var yyyy = today.getFullYear();

                if(dd<10)
                {
                    dd='0'+dd;
                }

                if(mm<10)
                {
                    mm='0'+mm;
                }
                today = yyyy + '-' + mm + '-' + dd;
                return today
            },
            pickFile_logo () {
                this.$refs.image_logo.click ()
            },
            onFilePicked_logo (e) {
                const files = e.target.files
                if(files[0] !== undefined) {
                    this.logo_imageName = files[0].name
                    if(this.logo_imageName.lastIndexOf('.') <= 0) {
                        return
                    }
                    const fr = new FileReader ()
                    fr.readAsDataURL(files[0])
                    fr.addEventListener('load', () => {
                        this.logo_imageUrl = fr.result
                        this.logo_imageFile = files[0] // this is an image file that can be sent to server...
                    })
                } else {
                    this.logo_imageName = ''
                    this.logo_imageFile = ''
                    this.logo_imageUrl = ''
                }
            },
            onChange (data) {
                console.log(data)
                this.cellphone_plus_country_code = data.e164
                // console.log(data.formattedNumber)
                // console.log(data.isValid)
                this.band_cellphone = data.isValid
                // Object.assign(this, {
                //   nationalNumber,
                //   countryCode: data.countryCode
                // })
            },
            fullNamePlusCellphone: item => item.email + ' ' + item.celular + ' ' + item.first_name + ' ' + item.last_name,
            upgradeUserToSupplier () {
              this.loading = true
              this.errores = []
              const config = {
                method: 'PATCH',
                url: 'https://empresa-service.intrare.app/UserPlatformUpdateProvider/' + this.email2 + '/',
                headers: {
                  'Content-Type': 'application/json',
                  'authorization': 'Token ' + store.getters.getToken
                },
                data: {
                }
              };
              axios(config)
                .then(ok => {
                  this.loading = false
                  this.$store.commit('snackbar_activate_true')
                  this.$store.commit('snackbar_change_message', this.$t('msg_upgrade_user_provider_from_register_user'))
                  this.dialog_move_up = false
                  setTimeout(this.clear, 3000)
                  console.log('Token y Host Modificados en Usuario.')
                })
                .catch(error => {
                  this.loading = false
                  if(error.response.status == 400
                    && typeof error.response.data == "object"
                    && error.response.data)
                    this.errores = error.response.data
                  if(error.response.status == 404) {
                    console.log('No encontrado')
                    this.errores.idUsuario = 'Campo Requerido'
                  }
                })
            }
        }
    }
</script>
